export const ACCOUNT_CONTACTS = {
  primary_contact: { key: 'primary_contact', label: 'Primary Contact' },
  primary_billing: { key: 'primary_billing', label: 'Billing Contact' },
  primary_support: { key: 'primary_support', label: 'Support Contact' },
} as const;

export type AccountContactKey = keyof typeof ACCOUNT_CONTACTS;
export const ACCOUNT_CONTACT_KEYS = Object.keys(ACCOUNT_CONTACTS) as AccountContactKey[];
